import { CHANGE_CONFIG, CHANGE_PAGE_TEMPLATE, CHANGE_PAGE_ORIENTATION, CHANGE_PAGE_SIZE, CHANGE_PAGE_MARGINS, CHANGE_PREVIEW_HIDDEN_COMPONENTS, } from './constants';
export const changePageTemplate = (tempIdent) => (dispatch, getState) => {
    // TODO: je to dobre, prehazovat si cast state z jednoho reduceru do druheho ???
    const templates = getState().config.templates;
    const templateIdent = tempIdent || Object.keys(templates)[0];
    dispatch({
        type: CHANGE_PAGE_TEMPLATE,
        templateIdent,
        template: templates[templateIdent],
    });
};
export const changePageSize = (size) => ({
    type: CHANGE_PAGE_SIZE,
    size,
});
export const changePageOrientation = (orientation) => ({
    type: CHANGE_PAGE_ORIENTATION,
    orientation,
});
export const changePageMargins = (margins) => ({
    type: CHANGE_PAGE_MARGINS,
    margins,
});
export const changePreviewHiddenComponents = () => (dispatch, getState) => {
    const hiddenComponents = [];
    const state = getState();
    for (const key in state) {
        // eslint-disable-next-line no-prototype-builtins
        if (state.hasOwnProperty(key)) {
            state[key].isHidden && hiddenComponents.push(key);
        }
    }
    dispatch({
        type: CHANGE_PREVIEW_HIDDEN_COMPONENTS,
        hiddenComponents,
    });
};
/**
 * Vyvolano pri znovuspusteni Repexu a zpracovano ve withReducer
 * @param config objekt konfigurace
 */
export const changeConfig = (config) => ({
    type: CHANGE_CONFIG,
    config,
});
//# sourceMappingURL=actions.js.map